import { ENUM_APP_NAME } from "@/configs/enums/enum";
import { axiosClient } from "@/configs/helpers/AxiosHelper";
import type { typeGetAlert } from "@/configs/types/Alert/typeAlert";

import type { typeGetPagination } from "@/configs/types/Shared/typePagination";

export class fetchAlert {
  async List(params: object): Promise<any> {
    const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.POLICE_COMMAND_CENTER).get<typeGetPagination<typeGetAlert>>("/v1/alerts", { params });
    Object.assign(data, {
      items: data.items?.map((i) => {
        Object.assign(i, { area: (i.area as number) / 1000 })
        return i
      })
    })
    return data;
  }

  async Create(body: typeGetAlert): Promise<typeGetAlert> {
    Object.assign(body, {
      area: (body.area as number) * 1000
    })
    const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.POLICE_COMMAND_CENTER).post<typeGetAlert>("/v1/alerts", body);
    return data;
  }

  async Get(id: string): Promise<typeGetAlert> {
    const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.POLICE_COMMAND_CENTER).get<typeGetAlert>(`/v1/alerts/${id}`);
    Object.assign(data, {
      area: (data.area as number) / 1000
    })
    return data;
  }

  async Update(id: string, body: typeGetAlert): Promise<typeGetAlert> {
    Object.assign(body, {
      area: (body.area as number) * 1000
    })
    const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.POLICE_COMMAND_CENTER).put<typeGetAlert>(`/v1/alerts/${id}`, body);
    return data;
  }

  async Delete(id: string): Promise<typeGetAlert> {
    const { data } = await axiosClient({ isFile: false }, ENUM_APP_NAME.POLICE_COMMAND_CENTER).delete<typeGetAlert>(`/v1/alerts/${id}`);
    return data;
  }
}
